function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.85714 3.50002C3.85714 4.20817 3.27958 4.78573 2.57143 4.78573C1.86328 4.78573 1.28571 4.20817 1.28571 3.50002C1.28571 2.79187 1.86328 2.21431 2.57143 2.21431C3.27958 2.21431 3.85714 2.79187 3.85714 3.50002ZM5.14286 3.50002C5.14286 2.0787 3.99275 0.928589 2.57143 0.928589C1.15011 0.928589 0 2.0787 0 3.50002C0 3.80638 0.0351562 4.12279 0.165737 4.39902L1.99888 8.28629C2.09933 8.50727 2.33036 8.64288 2.57143 8.64288C2.8125 8.64288 3.04353 8.50727 3.149 8.28629L4.97712 4.39902C5.1077 4.12279 5.14286 3.80638 5.14286 3.50002Z",
  fill: "#D82067"
});

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Map.30dd1335.svg";
export { ForwardRef as ReactComponent };